export const ID62 = () => {
    return (
        <div>
            <div className="section-product__about-card">
                <div className="sections_text">
                    <h1>1С-Рейтинг: Бюджетирование предприятия</h1>

                    <div className="section__tab" id="01" >
                        <div className="about-card__title">
                            Характеристика конфигурации
                        </div>
                        <p><b>Прикладное решение «1С-Рейтинг: Бюджетирование предприятия» предназначено для
                            автоматизации процессов бюджетирования предприятий, осуществляющих любые виды коммерческой
                            деятельности. Позволяет автоматизировать все шаги бюджетного процесса – от создания
                            структуры бюджетов и ввода плановых данных до автоматизированного сбора фактических данных в
                            режиме on-line и получения отчетности по план-фактному анализу бюджетов, также другой
                            аналитической отчетности.</b></p>

                        <p>«1С-Рейтинг: Бюджетирование предприятия» представляет собой дополнение к любой конфигурации
                            на платформе 1С:Предприятие 8, соответствующей минимальному перечню требований. Таким
                            образом, продукт может быть использован в любом регионе или стране. Кроме этого решение
                            может функционировать как самостоятельное.</p>

                        <p>Программный продукт будет наиболее эффективен на предприятиях, заинтересованных в оперативном
                            управлении финансовыми потоками и финансовом планировании. Используя прикладное решение
                            «1С-Рейтинг: Бюджетирование предприятия», предприятие получает инструменты планирования
                            финансового состояния, составления мастер-бюджетов (бюджет доходов и расходов, бюджет
                            движения денежных средств, прогнозный баланс) и других оборотных бюджетов, анализа
                            отклонений плановых и фактических данных.</p>

                        <p>С помощью прикладного решения «1С-Рейтинг: Бюджетирование предприятия» предприятие может
                            автоматизировать следующие процессы:</p>

                        <ul>
                            <li>финансовое планирование (бюджетирование и отражение фактических данных в бюджетах);</li>

                            <li>групповое согласование и утверждение документов.</li>
                        </ul>

                        <p><b>Прикладное решение включает следующие подсистемы:</b></p>

                        <p><b>Подсистема «Бюджетирование»</b> реализует функции, необходимые для построения системы
                            финансового управления на предприятии:</p>

                        <ul>
                            <li>постановка системы бюджетирования в целом для предприятия или холдинга;</li>

                            <li>настройка структуры бюджетов согласно потребностям предприятия. Возможность
                                версионирования состава статей бюджета;
                            </li>

                            <li>возможность сценарного планирования бюджетов - параллельного планирования бюджетов с
                                различными вариантами развития событий, различной структурой бюджетного периода и
                                горизонтом планирования, также возможность сценарного планирования с применением
                                моделирования курса валют;
                            </li>

                            <li>пакетное создание бюджетов путем копирования бюджетов других периодов или сценариев с
                                применением поправочных коэффициентов на все, либо выбранные статьи формируемого
                                бюджета;
                            </li>

                            <li>формирование бюджетного регламента, гибкая настройка схем автоматического получения
                                сводных и консолидированных бюджетов различными способами;
                            </li>

                            <li>календарное планирование исполнения и контроля исполнения задач пользователей в рамках
                                процесса бюджетирования;
                            </li>

                            <li>упрощение работы пользователя по вводу плановых показателей - настройка различного рода
                                зависимостей между статьями бюджета или различных бюджетов и настройка моделей расчета
                                для отдельных статей (как на основании других плановых данных, так и на основании данных
                                регламентированного учета – например, остатков товаров или денежных средств и т.д.),
                                автоматическое выполнение расчетов на основании установленных зависимостей и моделей;
                            </li>

                            <li>раздельное формирование бюджетов подразделений и проектов, с возможностью
                                автоматического объединения в сводные и консолидированные бюджеты;
                            </li>

                            <li>планирование бюджетов предприятия в натуральных и суммовых показателях, с применением
                                различной детализации по измерениям бюджетирования (дополнительной аналитики) – центрам
                                ответственности, проектам, контрагентам и номенклатурным позициям. Предусмотрена
                                возможность определить до десяти дополнительных разрезов, ссылающихся на выбранную
                                пользователем справочную информацию;
                            </li>

                            <li>поддержка схем планирования бюджетов «сверху-вниз» и «снизу-вверх»;</li>

                            <li>подача заявок от подразделений на формирование бюджетов и автоматизированное
                                формирование бюджетов на основании поданных заявок;
                            </li>

                            <li>корректировка бюджетов, поддержка версионности корректируемых бюджетов. Учет и анализ
                                причин корректировок;
                            </li>

                            <li>настраиваемые формы печати и отчетности по бюджетам (в т.ч. на нескольких языках),
                                исключение внутригрупповых оборотов из отчетов;
                            </li>

                            <li>установка лимитов (контрольных границ) – целевых (для анализа превышений в отчетности) и
                                ограничивающих (для недопущения формирования плановых или фактических операций сверх
                                лимита). В качестве лимитов могут использоваться сформированные бюджеты определенного
                                сценария планирования;
                            </li>

                            <li>возможность планирования остаточных показателей (в том числе и для преемственности
                                бюджетов следующих периодов) и ведения управленческого учета на предприятии на основании
                                управленческого плана счетов, структура которого может определяться пользователем для
                                собственных нужд;
                            </li>

                            <li>мониторинг фактической деятельности предприятия в тех же разрезах, в которых проводилось
                                планирование;
                            </li>

                            <li>полностью настраиваемые схемы отражения фактических данных в бюджетах предприятия и на
                                счетах управленческого плана счетов предоставляют предприятию возможность постановки
                                финансового (управленческого) учета и контроля фактических данных в соответствии с
                                собственными потребностями;
                            </li>

                            <li>возможность контроля фактически отражаемых операций на основании заложенных в бюджетах
                                предприятия показателей;
                            </li>

                            <li>составление сводной отчетности по результатам мониторинга;</li>

                            <li>финансовый анализ, самостоятельная настройка выполнения финансовых анализов и финансовых
                                расчетов в соответствии с требованиями предприятия;
                            </li>

                            <li>анализ отклонений плановых и фактических данных, сценарный анализ данных
                                бюджетирования;
                            </li>

                            <li>отчетность по управленческому плану счетов.</li>
                        </ul>

                        <p><b>Подсистема «Управление согласованием и утверждением документов»</b> предоставляет
                            возможность создания маршрутов согласования и утверждения документов для совместной работы и
                            контроля отдельных хозяйственных операций. Доступны следующие возможности:</p>

                        <ul>
                            <li>настройка маршрутов для определенного перечня документов;</li>

                            <li>назначение для одного вида документов нескольких маршрутов, применяемых в зависимости от
                                условий использования и вычисляемых применительно к конкретному экземпляру – документу;
                            </li>

                            <li>произвольное создание точек маршрута – этапов;</li>

                            <li>назначение прав подписи отдельным пользователям, либо группам пользователей, по этапам
                                маршрутов;
                            </li>

                            <li>настройка контроля и автоматического заполнения отдельных реквизитов первичных
                                документов при прохождении этапов согласования и утверждения;
                            </li>

                            <li>формирование списка задач исполнителям;</li>

                            <li>отчетность по состоянию документов на маршрутах;</li>

                            <li>формирование карт маршрутов и карт движения документов по маршрутам;</li>

                            <li>мониторинг состояния выбранных документов – постановка на контроль;</li>

                            <li>мониторинг состояния отдельных документов из формы списка документов и из формы
                                документа, вывод сведений о собранных подписях;
                            </li>

                            <li>настройка условного использования отдельных этапов маршрута;</li>

                            <li>возможность выполнения автоматических действий на этапах маршрута в зависимости от
                                выполнения условий по документу – автоматическое утверждение, отклонение или возврат
                                документа на пересмотр для более эффективного использования времени кадровых ресурсов
                                предприятия;
                            </li>

                            <li>защита от изменения согласуемых документов.</li>
                        </ul>

                        <p>В прикладном решении предусмотрен большой набор ролей, достаточно автономных и позволяющих
                            модульно назначать каждому пользователю только те функции, к которым он должен иметь
                            доступ.</p>

                        <p>Программный продукт «1С-Рейтинг: Бюджетирование предприятия» не включает платформу, для его
                            работы необходимо наличие конфигураций системы программ «1С:Предприятие 8», включающих
                            платформу.</p>
                        <a href="http://1c-rating.kz/sol/adviser/">Онлайн-демонстрация с консультантом</a>
                        <p>Интернет-демонстрация с консультантом позволит Вам получить наиболее полную и достоверную
                            информацию о возможностях прикладного решения. Консультант в режиме реального времени
                            продемонстрирует и подробно расскажет обо всех подсистемах и механизмах прикладного решения,
                            ответит на возникшие вопросы.</p>

                        <p>Перейдя на <a href="http://1c-rating.kz/sol/adviser/"
                                         title="Заявка на интернет-демонстрацию отраслевого решения с консультантом"
                                         target="_self">страницу оформления заявки на демонстрацию</a>, Вы сможете
                            указать интересующие Вас вопросы и/или разделы прикладного решения, которые необходимо
                            рассмотреть во время интернет-демонстрации. Демонстрация проводится при помощи стандартных
                            средств интернет-браузера, с видео и аудио трансляцией.</p>

                        <p>После оформления заявки с Вами свяжется консультант для уточнения времени проведения
                            демонстрации.</p>

                    </div>

                    <div className="section__tab" id="articles">
                        <div className="about-card__title">
                            Методические материалы
                        </div>

                        <div className="news-list-news">
                            <div className="news-list-news__items row">

                                <article className="news-list-news__item col-12" id="bx_3218110189_1307862">
                                    <div className="news-list-news__content">
                                        <div className="news-list-news__info">
                                            27.12.2022
                                        </div>
                                        <h3 className="news-list-news__title">
                                            Регистрация внешних документов в подсистеме согласования и утверждения </h3>

                                    </div>
                                    <a className="news-list-news__block-link" target="_blank"
                                       href="https://pro1c.kz/articles/upravlenie-soglasovaniem-i-utverzhdeniem-dokumentov/registratsiya-vneshnikh-dokumentov-v-podsisteme-soglasovaniya-i-utverzhdeniya/"></a>
                                </article>

                                <article className="news-list-news__item col-12" id="bx_3218110189_1307787">
                                    <div className="news-list-news__content">
                                        <div className="news-list-news__info">
                                            12.12.2022
                                        </div>
                                        <h3 className="news-list-news__title">
                                            Способы формирования бюджетов в конфигурации «1С-Рейтинг: Бюджетирование
                                            предприятия» </h3>
                                        <div className="news-list-news__details">

                                        </div>
                                    </div>
                                    <a className="news-list-news__block-link" target="_blank"
                                       href="https://pro1c.kz/articles/byudzhetirovanie/sposoby-formirovaniya-byudzhetov-v-konfiguratsii-1s-reyting-byudzhetirovanie-predpriyatiya/"></a>
                                </article>

                                <article className="news-list-news__item col-12" id="bx_3218110189_1307455">
                                    <div className="news-list-news__content">
                                        <div className="news-list-news__info">
                                            31.10.2022
                                        </div>
                                        <h3 className="news-list-news__title">
                                            Настройка этапов маршрутов согласования в конфигурации «1С-Рейтинг:
                                            Бюджетирование предприятия» </h3>
                                        <div className="news-list-news__details">

                                        </div>
                                    </div>
                                    <a className="news-list-news__block-link" target="_blank"
                                       href="https://pro1c.kz/articles/upravlenie-soglasovaniem-i-utverzhdeniem-dokumentov/nastroyka-etapov-marshrutov-soglasovaniya-v-konfiguratsii-1s-reyting-byudzhetirovanie-predpriyatiya/"></a>
                                </article>

                                <article className="news-list-news__item col-12" id="bx_3218110189_1303123">
                                    <div className="news-list-news__content">
                                        <div className="news-list-news__info">
                                            27.09.2022
                                        </div>
                                        <h3 className="news-list-news__title">
                                            Маршруты согласования и утверждения документов </h3>
                                        <div className="news-list-news__details">

                                        </div>
                                    </div>
                                    <a className="news-list-news__block-link" target="_blank"
                                       href="https://pro1c.kz/articles/upravlenie-soglasovaniem-i-utverzhdeniem-dokumentov/marshruty-soglasovaniya-i-utverzhdeniya-dokumentov/"></a>
                                </article>

                                <article className="news-list-news__item col-12" id="bx_3218110189_1303122">
                                    <div className="news-list-news__content">
                                        <div className="news-list-news__info">
                                            31.08.2022
                                        </div>
                                        <h3 className="news-list-news__title">
                                            Режимы постановки документов на маршрут в программном продукте «1С-Рейтинг:
                                            Бюджетирование предприятия» </h3>
                                        <div className="news-list-news__details">

                                        </div>
                                    </div>
                                    <a className="news-list-news__block-link" target="_blank"
                                       href="https://pro1c.kz/articles/upravlenie-soglasovaniem-i-utverzhdeniem-dokumentov/rezhimy-postanovki-dokumentov-na-marshrut-v-programmnom-produkte-1s-reyting-byudzhetirovanie-predpri/"></a>
                                </article>

                                <article className="news-list-news__item col-12" id="bx_3218110189_1303121">
                                    <div className="news-list-news__content">
                                        <div className="news-list-news__info">
                                            24.06.2022
                                        </div>
                                        <h3 className="news-list-news__title">
                                            Настройка замещения согласующего сотрудника в программном продукте
                                            «1С-Рейтинг: Бюджетирование предприятия» </h3>
                                        <div className="news-list-news__details">

                                        </div>
                                    </div>
                                    <a className="news-list-news__block-link" target="_blank"
                                       href="https://pro1c.kz/articles/upravlenie-soglasovaniem-i-utverzhdeniem-dokumentov/nastroyka-zameshcheniya-soglasuyushchego-sotrudnika-v-programmnom-produkte-1s-reyting-byudzhetirovan/"></a>
                                </article>

                                <article className="news-list-news__item col-12" id="bx_3218110189_1303120">
                                    <div className="news-list-news__content">
                                        <div className="news-list-news__info">
                                            31.01.2017
                                        </div>
                                        <h3 className="news-list-news__title">
                                            PRO формирование и утверждение бюджетов в «1С-Рейтинг: Комплексное
                                            управление финансами и Бюджетирование для Казахстана» </h3>
                                        <div className="news-list-news__details">

                                        </div>
                                    </div>
                                    <a className="news-list-news__block-link" target="_blank"
                                       href="https://pro1c.kz/articles/byudzhetirovanie/pro-formirovanie-i-utverzhdenie-byudzhetov-v-1s-reyting-kompleksnoe-upravlenie-finansami-i-byudzheti/"></a>
                                </article>

                                <article className="news-list-news__item col-12" id="bx_3218110189_1303119">
                                    <div className="news-list-news__content">
                                        <div className="news-list-news__info">
                                            31.01.2017
                                        </div>
                                        <h3 className="news-list-news__title">
                                            Актуализация и корректировка бюджетных данных в программном продукте
                                            «1С-Рейтинг: Комплексное управление финансами и Бюджетирование для
                                            Казахстана» </h3>
                                        <div className="news-list-news__details">

                                        </div>
                                    </div>
                                    <a className="news-list-news__block-link" target="_blank"
                                       href="https://pro1c.kz/articles/byudzhetirovanie/aktualizatsiya-i-korrektirovka-byudzhetnykh-dannykh-v-programmnom-produkte-1s-reyting-kompleksnoe-up/?sphrase_id=1392834"></a>
                                </article>

                                <article className="news-list-news__item col-12" id="bx_3218110189_1303118">
                                    <div className="news-list-news__content">
                                        <div className="news-list-news__info">
                                            31.01.2017
                                        </div>
                                        <h3 className="news-list-news__title">
                                            Сценарное планирования как механизм формирования гибких бюджетов в
                                            программном продукте «1С-Рейтинг: Комплексное управление финансами и
                                            Бюджетирование для Казахстана» </h3>
                                        <div className="news-list-news__details">

                                        </div>
                                    </div>
                                    <a className="news-list-news__block-link" target="_blank"
                                       href="https://pro1c.kz/articles/byudzhetirovanie/stsenarnoe-planirovaniya-kak-mekhanizm-formirovaniya-gibkikh-byudzhetov-v-programmnom-produkte-1s-re/?sphrase_id=1392827"></a>
                                </article>
                            </div>
                        </div>

                    </div>

                    <div className="section__tab" id="demo">
                        <div className="about-card__title">
                            Презентации
                        </div>
                        <ul>
                            <li><a target="_blank" href="/sol/presentations/budgeting/Budgeting 3.1.pptx">1С-Рейтинг:
                                Бюджетирование предприятия универсальное дополнение к любым учетным системам</a></li>
                        </ul>
                    </div>

                    <div className="section__tab" id="webinars">
                        <div className="about-card__title">
                            Вебинары
                        </div>
                        <div className="catalog-section">
                            <p></p>
                            <table>
                                <thead>
                                <tr>
                                    <th>Дата вебинара</th>
                                    <th>Название</th>
                                    <th>Видеозапись</th>
                                </tr>
                                </thead>
                                <thead>
                                <tr id="bx_3966226736_410022">
                                    <td>14.11.2017</td>
                                    <td>
                                        <a href="http://1c-rating.kz/news/410161/">
                                            Бюджетирование на раз, два, три! </a>
                                    </td>

                                    <td><a
                                        href="/upload/iblock/551/2017_11_14_budjetirovaniye-na-raz-dva-tri.zip">Cкачать</a>
                                    </td>
                                </tr>

                                <tr id="bx_3966226736_405332">
                                    <td>12.10.2017</td>
                                    <td>
                                        <a href="http://1c-rating.kz/news/405783/">
                                            Визирование документов - как инструмент контроля управленческих решений в
                                            «1С-Рейтинг: Бюджетирование предприятия» </a>
                                    </td>

                                    <td><a
                                        href="/upload/iblock/92b/2017-10-12-vizirovanie-dokumentovj-v-1s-rejting-byudzhetirovanie-predpriyatiya.zip">Cкачать</a>
                                    </td>
                                </tr>

                                <tr id="bx_3966226736_402847">
                                    <td>21.09.2017</td>
                                    <td>
                                        <a href="http://1c-rating.kz/news/403135/">
                                            На ступеньку выше. Обзор новой редакции «1С-Рейтинг: Бюджетирование
                                            предприятия» </a>
                                    </td>

                                    <td><a
                                        href="/upload/iblock/0e6/2017-9-21-na-stupenku-vyshe-obzor-novoj-redakcii-1s-rejting_byudzhetirovanie-predpriyatiya.zip">Cкачать</a>
                                    </td>
                                </tr>


                                </thead>
                            </table>
                        </div>

                    </div>

                    <div className="section__tab" id="addto">
                        <div className="about-card__title">
                            Дополнение
                        </div>
                        <ul>
                            <li><a href="/sol/bgu">Госсектор: Бухгалтерия государственного учреждения для Казахстана</a>
                            </li>
                            <li><a href="/sol/buhgp">1С-Рейтинг: Бухгалтерия государственного предприятия</a></li>
                            <li><a href="/sol/buhgp_med">1С-Рейтинг: Бухгалтерия организации здравоохранения для
                                Казахстана</a></li>
                            <li><a href="/sol/buhgp_edu">1С-Рейтинг: Бухгалтерия учебного заведения для Казахстана</a>
                            </li>
                            <li><a href="/sol/gsm">1С-Рейтинг: Нефтебаза</a></li>
                            <li><a href="/sol/food">1С-Рейтинг: Общепит для Казахстана</a></li>
                            <li><a href="/sol/elevator">1С-Рейтинг: Элеватор</a></li>
                        </ul>
                    </div>

                    <div className="section__tab" id="price">
                        <div className="table-responsive">
                            <div className="about-card__title">
                                Цены
                            </div>
                            <table>
                                <tbody>
                                <tr>
                                    <th>Наименование</th>
                                    <th width="70">Цена, тенге</th>
                                </tr>
                                <tr>
                                    <td>1С-Рейтинг: Бюджетирование предприятия. (Электронная поставка)</td>
                                    <td>255 000</td>
                                </tr>
                                <tr>
                                    <td>1С-Рейтинг: Бюджетирование предприятия. Комплект на 5 пользователей.
                                        (Электронная поставка)
                                    </td>
                                    <td>438 000</td>
                                </tr>
                                <tr>
                                    <td>1С-Рейтинг: Бюджетирование предприятия. Дополнительная лицензия на 1 рабочее
                                        место. (Электронная поставка)
                                    </td>
                                    <td>72 000</td>
                                </tr>
                                <tr>
                                    <td>1С-Рейтинг: Бюджетирование предприятия. Дополнительная лицензия на 5 рабочих
                                        мест. (Электронная поставка)
                                    </td>
                                    <td>270 000</td>
                                </tr>
                                <tr>
                                    <td>1С-Рейтинг: Бюджетирование предприятия. Дополнительная лицензия на 10 рабочих
                                        мест. (Электронная поставка)
                                    </td>
                                    <td>504 000</td>
                                </tr>
                                <tr>
                                    <td>1С-Рейтинг: Бюджетирование предприятия</td>
                                    <td>255&nbsp;000</td>
                                </tr>
                                <tr>
                                    <td>1С-Рейтинг: Бюджетирование предприятия. Комплект на 5 пользователей</td>
                                    <td>438 000</td>
                                </tr>
                                <tr>
                                    <td>1С-Рейтинг: Бюджетирование предприятия. Дополнительная лицензия на 1 рабочее
                                        место
                                    </td>
                                    <td>72 000</td>
                                </tr>
                                <tr>
                                    <td>1С-Рейтинг: Бюджетирование предприятия. Дополнительная лицензия на 5 рабочих
                                        мест
                                    </td>
                                    <td>270 000</td>
                                </tr>
                                <tr>
                                    <td>1С-Рейтинг: Бюджетирование предприятия. Дополнительная лицензия на 10 рабочих
                                        мест
                                    </td>
                                    <td>504 000</td>
                                </tr>
                                <tr>
                                    <td>1С-Рейтинг: Бюджетирование предприятия (USB)</td>
                                    <td>270&nbsp;000</td>
                                </tr>
                                <tr>
                                    <td>1С-Рейтинг: Бюджетирование предприятия (USB). Комплект на 5 пользователей</td>
                                    <td>492 700</td>
                                </tr>
                                <tr>
                                    <td>1С-Рейтинг: Бюджетирование предприятия. Дополнительная лицензия на 1 рабочее
                                        место. (USB)
                                    </td>
                                    <td>81 000</td>
                                </tr>
                                <tr>
                                    <td>1С-Рейтинг: Бюджетирование предприятия. Дополнительная лицензия на 5 рабочих
                                        мест. (USB)
                                    </td>
                                    <td>303 750</td>
                                </tr>
                                <tr>
                                    <td>1С-Рейтинг: Бюджетирование предприятия. Дополнительная лицензия на 10 рабочих
                                        мест. (USB)
                                    </td>
                                    <td>567 000</td>
                                </tr>
                                </tbody>
                            </table>
                            <p><span>*</span> Цены указаны без учета стоимости платформы
                                и лицензий на платформу «1С:Предприятие 8».</p>

                            <p>С ценами на типовые конфигурации и дополнительные лицензии на платформу «1С:Предприятие
                                8» можно ознакомиться по <a id="bxid_198342" href="http://1c-rating.kz/price/"
                                                            title="Цены на 1С:Предприятие 8" target="_self">ссылке</a>.
                            </p>
                        </div>


                        <div className="solution__support">
                            <div className="about-card__title">
                                Поддержка и условия сопровождения отраслевых решений 1С-Рейтинг
                            </div>
                            <p>Приобретая отраслевые и специализированные решения, пользователи получают льготный
                                (бесплатный) период поддержки на 3 месяца. После окончания льготного срока поддержки,
                                для получения обновлений и консультационно-методического сопровождения по ТОР,
                                пользователям необходимо приобрести и активировать Лицензию на методическую и
                                технологическую поддержку на требуемый срок. <a href="/sol/support.php">Подробнее...</a>
                            </p></div>
                    </div>

                </div>
            </div>
        </div>
    )
}